import { QuestionCircleFilled } from '@ant-design/icons';
import { Button, Card, Flex, Tooltip, notification } from 'antd';
import { throttle } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Server } from '../../../api/server-index';
import MainTitle from '../../common/titles/main-title.component';

const Settings = () => {
  const { t } = useTranslation('settings');
  const [isThrottled, setIsThrottled] = useState(false);

  const sendChangePasswordEmail = throttle(async () => {
    setIsThrottled(false);
    const response = await Server.User.changePassword();
    if (response.status === 200) {
      notification.success({ message: t('password.change.success') });
    }
  }, 180000);

  const handleSendClick = () => {
    if (isThrottled) {
      notification.warning({ message: t('password.change.limit') });
      return;
    }

    setIsThrottled(true);
    sendChangePasswordEmail();
  };

  return (
    <div>
      <MainTitle text={t('title')} />
      <Card className='shadow-sm'>
        <Flex gap={8}>
          <h4>{t('password.change.title')}</h4>
          <Tooltip title={t('password.change.tooltip')}>
            <QuestionCircleFilled />
          </Tooltip>
        </Flex>
        <Button onClick={() => handleSendClick()} type='primary' ghost>
          {t('password.change.send')}
        </Button>
      </Card>
    </div>
  );
};

export default Settings;
